<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      return appConfig.title
      // title = typeof title === 'function' ? title(this.$store) : title
      // return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <VApp>
    <div id="app">
      <!--
      Even when routes use the same component, treat them
      as distinct and create the component again.
      -->
      <!--eslint-disable-next-line-->
      <router-view :key="$route.fullPath"/>
    </div>
  </VApp>
</template>

<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';
@import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500');

// Mapbox
@import url('https://api.mapbox.com/mapbox-gl-js/v0.52.0/mapbox-gl.css');
@import url('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v2.3.0/mapbox-gl-geocoder.css');

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif !important;
  background: $color-body-bg;
}

#app {
  @extend %typography-small;
  font-family: 'Poppins', sans-serif !important;
}

#map {
  height: 70vh !important;
  width: 100% !important;
}

.mapboxgl-canvas {
  position: unset !important;
  width: 100% !important;
  height: auto !important;
}

.marker {
  width: 50px;
  height: 50px;
  cursor: pointer;
  background-image: url('../src/assets/images/REDTRUCK.png');
  background-size: contain;
}

.client-marker {
  width: 25px;
  height: 25px;
  cursor: pointer;
  background-image: url('../src/assets/images/client_marker.png');
  background-size: contain;
}
.depot-marker {
  width: 35px;
  height: 35px;
  cursor: pointer;
  background-image: url('../src/assets/images/depot_marker.png');
  background-size: contain;
}

.mapboxgl-popup {
  max-width: 200px;
}

.mapboxgl-popup-content {
  text-align: center;
  font-family: 'Poppins', sans-serif !important;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

.customLink,
.customLink:visited {
  color: lighten($color-text, 20%);
}

p {
  font-family: 'Poppins', sans-serif !important;
}

h1 {
  @extend %typography-xxlarge;
  font-family: 'Poppins', sans-serif !important;
}

h2 {
  margin: 15px 0;
  //font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.3;
  color: $blue;
}

h3 {
  @extend %typography-large;
  font-size: 1.5rem;
  padding: 0 !important;
  text-align: left !important;
  font-family: 'Poppins', sans-serif !important;
}

h4 {
  @extend %typography-medium;
  font-family: 'Poppins', sans-serif !important;
}

h5,
h6 {
  @extend %typography-small;
  font-family: 'Poppins', sans-serif !important;
}

strong {
  margin-right: 8px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px;
  font-weight: 400 !important;
}


.strongReport{
  font-weight: bold !important;
  letter-spacing: 1px;
}

#containerLogin {
  position: fixed;
  top: 0;
  left: 0;
  //z-index: -1;
  width: 100%;
  height: 50%;
  background-image: linear-gradient(
    to top right,
    $blue-gradient-start,
    $blue-gradient-end
  ) !important;
}

#blockLogin {
  margin: 0 auto;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}

// ===
// Vuetify overrides
// ===

// Side Navigation
nav {
  z-index: 1000;
}

.v-navigation-drawer {
  position: fixed !important; // Added this to scroll only content
}

.v-list__tile--link {
  transition: background-image 0.3s !important;
  &:hover {
    // background-color: $blue !important;
    background-image: linear-gradient(
      to top right,
      $blue-gradient-start,
      $blue-gradient-end
    ) !important;
  }
  &:focus {
    // background-color: $blue !important;
    background-image: linear-gradient(
      to top right,
      $blue-gradient-start,
      $blue-gradient-end
    ) !important;
    outline: none;
  }
  &:active {
    background-color: $blue !important;
  }

  &:has(.active) {
    background-color: $blue !important;
  }
}

.v-list__group__header {
  &:hover {
    // background-color: $blue !important;
    background-image: linear-gradient(
      to top right,
      $blue-gradient-start,
      $blue-gradient-end
    ) !important;
  }
  &:focus {
    // background-color: $blue !important;
    background-image: linear-gradient(
      to top right,
      $blue-gradient-start,
      $blue-gradient-end
    ) !important;
    outline: none;
  }
  &:active {
    // background-color: $blue !important;
    background-image: linear-gradient(
      to top right,
      $blue-gradient-start,
      $blue-gradient-end
    ) !important;
  }
}

.v-navigation-drawer {
  background-color: $dark-grey !important;
}

.v-btn.theme--light.blue {
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  color: $white;
  background-color: $blue !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $blue !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $blue !important;
  box-shadow: 1px 1px 8px 0.01px $blue !important;
}

.v-btn.theme--light.orange {
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  color: $white;
  background-color: $orange !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $orange !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $orange !important;
  box-shadow: 1px 1px 8px 0.01px $orange !important;
}

.v-btn.theme--light.green {
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  color: $white;
  background-color: $green !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $green !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $green !important;
  box-shadow: 1px 1px 8px 0.01px $green !important;
}

.v-btn--outline {
  border-color: $blue !important;
}

.v-btn__content {
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
}

.v-btn.theme--light.white {
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  color: $blue;
  -webkit-box-shadow: 0 0 10px 2px $shadow-black !important;
  -moz-box-shadow: 0 0 10px 2px $shadow-black !important;
  box-shadow: 0 0 10px 2px $shadow-black !important;
}

// Card styling
.v-card {
  border-radius: 5px !important;
  -webkit-box-shadow: 0 0 10px 2px $shadow-black !important;
  -moz-box-shadow: 0 0 10px 2px $shadow-black !important;
  box-shadow: 0 0 10px 2px $shadow-black !important;
}
.v-card-padding {
  padding: 20px;
}

// Form styling

label {
  font-size: 14px !important;
}

.v-input__slot {
  .v-menu {
    position: static !important;
  }
}

.v-menu__content.theme--light.menuable__content__active {
  top: 37px !important;
}

// Dialog styleling

.v-dialog.v-dialog--active.v-dialog--persistent {
  overflow-y: visible;
}

// Table styling
.v-table__overflow {
  margin-top: 20px;
  border-radius: 5px 5px 0 0;
}

.v-datatable td .v-btn.theme--light.blue {
  height: 27px;
  margin-top: 14px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 13px;
  color: $white;
  text-transform: capitalize;
  background-color: $blue !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $blue !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $blue !important;
  box-shadow: 1px 1px 8px 0.01px $blue !important;
}

.v-datatable td .v-btn.theme--light.green {
  height: 27px;
  margin-top: 14px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 13px;
  color: $white;
  text-transform: capitalize;
  background-color: $color-link-text !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $color-link-text !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $color-link-text !important;
  box-shadow: 1px 1px 8px 0.01px $color-link-text !important;
}

.v-datatable td .v-btn.theme--light.orange {
  height: 27px;
  margin-top: 14px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 13px;
  color: $white;
  text-transform: capitalize;
  background-color: $orange !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $orange !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $orange !important;
  box-shadow: 1px 1px 8px 0.01px $orange !important;
}

.v-datatable td .v-btn.theme--light.yellow {
  height: 27px;
  margin-top: 14px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 13px;
  color: $white;
  text-transform: capitalize;
  background-color: $yellow !important;
  -webkit-box-shadow: 1px 1px 8px 0.01px $yellow !important;
  -moz-box-shadow: 1px 1px 8px 0.01px $yellow !important;
  box-shadow: 1px 1px 8px 0.01px $yellow !important;
}

.v-datatable th.column {
  font-size: 14px !important;
  color: white !important;
}

.v-datatable th i {
  color: white !important;
}

.v-datatable thead {
  // background-color: $dark-grey !important;
  // font-family: $poppins-medium !important;
  font-family: 'Poppins', sans-serif !important;
  border-bottom: 10px solid $color-body-bg !important;
  border-radius: 5px !important;
}

table.v-datatable th {
  color: $dark-grey !important;
  background-color: $dark-grey !important;
}

table.v-datatable th:first-child {
  border-radius: 5px 0 0 5px !important;
}

table.v-datatable tr {
  /*border: 0 !important;*/
  border-bottom: 1px solid grey;
  padding-bottom: 50px !important;
}

table.v-datatable thead tr {
  border-radius: 5px 5px 5px 5px !important;
}

table.v-datatable tr:first-child {
  height: 44px !important;
}

table.v-datatable th:last-child {
  border-color: $color-body-bg !important;
  border-radius: 0 5px 5px 0 !important;
}

.v-datatable tbody {
  background-color: $color-body-bg !important;
  border-bottom: 10px solid $color-body-bg !important;
  border-radius: 5px !important;
  /*-webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75) !important;*/
  /*-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75) !important;*/
  /*box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75) !important;*/
}

.v-datatable tbody td {
  background-color: $white !important;
}

.v-datatable__actions {
  height: 40px;
  // font-family: $poppins-medium !important;
  font-family: 'Poppins', sans-serif !important;
  color: white !important;
  background-color: $dark-grey !important;
  border: 0 solid white !important;
  border-radius: 5px !important;
}

.v-datatable__actions i.v-icon.material-icons.theme--light {
  color: white !important;
}

.v-datatable.v-table.theme--light {
  background-color: $color-body-bg !important;
  border-radius: 5px !important;
}

table.v-table tbody td {
  height: 55px !important;
}

table.v-datatable tr:first-child td.text-xs-left:first-child {
  // border-radius: 15px 0 0 0 !important;
}

.isCompleted{
  color: $green !important;
}

.scrollable {
  width: 100%;
  height: 100%;
  padding-bottom: 5px;
  padding-top: 5px;
  overflow: auto;
}

.client-card {
  .flex {
    padding: 15px !important;
  }
  .client-details {
    border: 0 solid #d8d8d8;
    border-right-width: 1px;
  }
}
.top-blue {
  border: 0 solid $blue;
  border-top-width: 10px;
}
.agreement-card {
  margin-bottom: 30px;
  .agreement-notes {
    height: 150px;
    padding: 15px;
    background-color: #f2f2f2;
    border: 1px solid #d1d1d1;
    border-radius: 5px;
  }
}
.v-expansion-panel_body {
  .flex {
    display: inline-block;
  }
}

.collectionContainer {
  padding: 20px !important;
  /*padding-bottom: 0px !important;*/
  margin-bottom: 30px;
  background-color: white !important;
  border-radius: 5px !important;
  -webkit-box-shadow: 0 0 10px 2px $shadow-black !important;
  -moz-box-shadow: 0 0 10px 2px $shadow-black !important;
  box-shadow: 0 0 10px 2px $shadow-black !important;
}

.orderContainer {
  display: flex;
  align-items: center;
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.fixedSpaceVertical {
  margin-bottom: 16px;
}

.fixedSpaceHorizontal {
  margin-right: 8px;
}

.tyre {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 40px;
  font-size: 18px;
  background-color: #00baff;
  border-radius: 5px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1) !important;
}

.tyre-white {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 40px;
  font-size: 18px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1) !important;
}

.tyre p,
.tyreDesc p,
.tyre-white p {
  margin: 0 !important;
  text-align: center;
}

.tyreDesc {
  align-items: center !important;
  vertical-align: middle !important;
  text-align: center;
}

#signatureFitter {
  width: 100% !important;
  padding-top: 1em;
  padding-bottom: 1em;
  margin-bottom: 1em;
  border: 1px solid grey;
  border-radius: 5px;
}
#signatureFitter img {
  width: 100% !important;
  height: auto;
}

.signature-notes {
  /*height: 150px;*/
  padding: 15px;
  background-color: #f2f2f2;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
}

.signature-notes h5 {
  padding-bottom: 0.8em;
  font-weight: bold;
}

.subtitleStrong {
  font-size: 1.1em;
  letter-spacing: 1px;
}

/* SERVICE TRUCK VIEW */
.serviceDesc p {
  margin: 0 !important;
}

.serviceTitle {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 !important;
  margin-bottom: 10px;
  margin-top: 10px;
}

.serviceTitle .titleRight {
  display: flex;
  align-items: center;
  width: 50%;
  height: 50px;
  padding-left: 10px !important;
  background-color: $grey;
}

.serviceTitle h5 {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  padding-left: 10px !important;
  background-color: $grey;
  font-size: 1.3rem;
  font-weight: 600;
}

.serviceTitle .titleLeft {
  display: flex;
  align-items: center;
  width: 50%;
  height: 50px;
  padding-left: 10px !important;
  margin-right: 20px;
  background-color: $grey;
}

.serviceContainer {
  padding-top: 0 !important;
  background-color: $grey;
}

.axlesContainer {
  padding-top: 0 !important;
  background-color: $grey;
  border-right: 10px solid white;
}

.axlesTitle {
  border-bottom: 10px solid white;
  min-height: 80px;
  text-align: center;
}

.axleSubtitle {
  padding-left: 10px !important;
  text-align: left;
}

.axlesTitle h5 {
  padding: 0 !important;
}

.axleItem {
  text-align: center;
  border-bottom: 10px solid white;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 0px;
}

.serviceContainerRight {
  padding-top: 0 !important;
  background-color: $grey;
  border-left: 10px solid white;
}

.whiteInput {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 40px;
  font-size: 18px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1) !important;
  margin: 0 !important;
}

@media screen and (max-width: 980px) {
  .v-navigation-drawer {
    margin-top: 50px !important;
  }
}

@media print {
  .v-navigation-drawer {
    visibility: hidden !important;
  }

  .v-toolbar {
    visibility: hidden !important;
  }

  .v-btn {
    visibility: hidden !important;
  }

  h2 {
    color: black;
    margin-bottom: -50px;
  }

  body {
    margin-left: -280px !important;
    width: calc(100% + 280px);
  }

  .collectionContainer {
    /*height: 100px;*/
    width: 100%;
    height: 100%;
    background-color: white !important;
    border-radius: 0 !important;
    -webkit-box-shadow: 0 0 0 0 white !important;
    -moz-box-shadow: 0 0 0 0 white !important;
    box-shadow: 0 0 0 0 white !important;
    border-bottom: 1px solid black;
    break-inside: avoid;
    padding: 0.2cm !important;
  }

  .other-pages{
    display: block;
    page-break-before: always;
  }

  .clientInfo{
    margin-right: 55px !important;
    /*page-break-inside:avoid;*/
    h5 {
      break-inside: avoid;
    }
  }

  .binsInfo {
    // padding-left: -50px !important;
    width: 100%;
    ul {
      break-inside: avoid !important;
    }
  }

  .runsheetWrapper {
    margin-bottom: 100px !important;
  }

  .buttonsContainer{
    display: none;
  }

  @page {
    margin: 2cm;
    size: 29.7cm 42.0cm;
    orphans: 4
  }

  @page :left {
    margin: 0cm;
  }

  @page :right {
    margin: 0cm;
  }


  #map {
    display: none;
  }

  .mapContainer {
    display: none;
  }

  .pagebreak {
    /*padding: 2cm;*/
    margin-bottom: 3cm;
    page-break-after: always;
  }
}

.isActive {
   border-color: #499bf8;
   border-style: solid;
 }
</style>
<!-- This should generally be the only global CSS in the app. -->
